import React, { type ReactElement } from 'react';

import { Banner } from '@pushwoosh/dumb-components';

import { H1, RouterLink } from '~/src/ui-kit';
import { useEnvironment } from '~/src/contexts/environment';
import { Lang, useLang } from '~/src/polyglot';

import { StyledContentBox } from './styles';

export function SuccessPage(): ReactElement {
  const { getLinkByName } = useEnvironment();
  const lang = useLang();

  return (
    <StyledContentBox>
      <H1><Lang message="CHANGE_PASSWORD.SUCCESS.TITLE" /></H1>
      <Banner
        type="info"
        view="ghost"
        title=""
      >
        <Lang message="CHANGE_PASSWORD.SUCCESS.MESSAGE" />
        {' '}
        <RouterLink title={lang({ message: 'CHANGE_PASSWORD.LINK.SIGN_IN' })} to={getLinkByName('login')}>
          <Lang message="CHANGE_PASSWORD.LINK.SIGN_IN" />
        </RouterLink>
      </Banner>
    </StyledContentBox>
  );
}
